
// SVG Icon: drag-drop
export default { id: "terriajs-drag-drop" };
export const id = "terriajs-drag-drop";
export const name = "drag-drop";
